import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import Text from '@amzn/meridian/text';
import { Paragraph, TruncatedParagraph, Link } from 'src/common/styled';
import { usePageContext } from 'src/hooks';
export const ReviewText = ({ text }) => {
    const [isExpanded, setIsExpanded] = React.useState(false);
    const [isTruncated, setIsTruncated] = React.useState(false);
    const textRef = React.useRef(null);
    const { bundle } = usePageContext();
    const toggleExpanded = () => {
        setIsExpanded(!isExpanded);
    };
    // Calculate whether text needs to be truncated based on actual height of review text.
    React.useEffect(() => {
        if (textRef.current && text) {
            const element = textRef.current;
            setIsTruncated(element.scrollHeight > element.clientHeight);
        }
    }, [text]);
    return (_jsxs("div", { "data-testid": "review-text-section", children: [isExpanded ? (_jsx(Paragraph, { type: "b200", "data-testid": "review-text-expanded", children: text })) : (_jsx(TruncatedParagraph, { clamp: 5, ref: textRef, type: "b200", "data-testid": "review-text-truncated", children: text })), isTruncated && (_jsx(Text, { type: "b200", children: _jsx(Link, { role: "button", onClick: toggleExpanded, "data-testid": "review-expander", children: bundle.getMessage(isExpanded ? 'seeLess' : 'seeMore') }) }))] }));
};
